import type { ButtonHTMLAttributes } from "react";
import { cn } from "@/shared/cn";

export function Pill({
  className,
  type = "button",
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      type={type}
      className={cn(
        "cursor-pointer whitespace-nowrap rounded-[20px] border border-(--line-strong) px-[15px] py-[7px]",
        "bg-[color-mix(in_srgb,var(--paper)_88%,transparent)] text-sm font-medium text-(--dim)",
        "shadow-[0_1px_2px_rgba(26,26,26,0.04),0_6px_18px_rgba(26,26,26,0.06)] backdrop-blur-[10px]",
        "transition-colors duration-(--duration-fast) hover:border-(--brand-line) hover:text-(--ink)",
        "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--brand)",
        className,
      )}
      {...rest}
    />
  );
}
